import React from 'react';
import Terrasse from '../Terrasse';

function TerrassePage() {
    return (
        <>
            <Terrasse />
        </>
    )
}

export default TerrassePage;
